var _path, _path2, _path3, _stop, _stop2, _feFlood, _feColorMatrix, _feOffset, _feGaussianBlur, _feComposite, _feColorMatrix2, _feBlend, _feBlend2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgDropzoneIconRight(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 231,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: `url(#${_id2})`
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.892 57.668a6.41 6.41 0 018.66-2.675l41.565 21.95 13.14 32.308-36.415 68.959a6.412 6.412 0 01-8.661 2.675l-59.513-31.427a6.423 6.423 0 01-3.13-3.777 6.409 6.409 0 01.456-4.884l43.898-83.13z",
    fill: "#FA5655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.114 76.94l-7.482 14.17a6.412 6.412 0 002.674 8.661l17.949 9.478",
    fill: "#DF2C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.813 143.122c-1.204-.637-2.199-1.664-2.956-3.051-1.576-2.891-.96-5.154-.167-6.545 2.788-4.884 12.178-6.396 20.026-6.768a94.56 94.56 0 008.068-12.872c-2.636-7.07-4.878-15.946-1.724-20.298.878-1.213 2.553-2.623 5.54-2.462 1.01.039 2 .298 2.9.76 4.918 2.597 4.468 10.483-1.245 22.26a97.135 97.135 0 006.911 13.803c4.185.697 9.568 1.932 13.519 4.018 3.023 1.597 4.845 3.525 5.417 5.732.313 1.211.391 3.112-1.023 5.283-2.135 3.278-5.635 4.061-9.36 2.095-4.321-2.283-8.582-7.876-11.579-12.524a96.48 96.48 0 00-14.895-.872c-5.696 7.195-13.445 14.6-19.432 11.441zm12.491-10.991c-3.958.462-12.975 2.012-11.048 5.542 1.965 3.607 8.323-2.558 11.048-5.542zm28.851 1.737c2.201 2.909 7.733 9.437 9.73 6.376 1.975-3.034-6.242-5.521-9.73-6.376zm-18.124-7.336a.28.28 0 00.241.146c2.433.055 4.863.195 7.286.42a.284.284 0 00.149-.027.285.285 0 00.113-.101 104.379 104.379 0 01-3.419-6.798.303.303 0 00-.256-.177 101.284 101.284 0 01-4.114 6.537zm5.3-30.406c-3.267-.178-1.388 7.909-.492 11.056 1.177-3.051 3.75-10.881.493-11.056z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M118 82c32.8-50.4 109-73.488 144-71.821V4c-32.667-7.333-109.8-7.4-157 51s-10.333 46.94 13 27z",
    fill: `url(#${_id})`
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 111.999,
    y1: 46,
    x2: 240.999,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5655",
    stopOpacity: 0.26
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA5655",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("filter", {
    id: _id2,
    x: 0.252,
    y: 53.251,
    width: 158.006,
    height: 177.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2338_12822"
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2338_12822",
    result: "shape"
  })))));
}
export default SvgDropzoneIconRight;